/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import { SelectedFilterTag } from './selected-filter-tag.js.jsx';

// Implements the dropdown + selected tag bubble list portion of a filter selector form row
//
// Expects the following props:
//   param: Name of parameter for embedded input type=hidden tags
//   options: Array of options for the SELECT dropdown
//            Should already be prepared for nested entries (with indent names, etc)
//            Each element should contain 3 elements: [Option Label, ID, Name]
//            Option label is the name used in the select (this has the indentation)
//            ID is the value to add to the list
//            Name is the name of the tag (for display in the selection bubble)
//   labels: Hash of id to option labels (spaces, indentation stripped)
//   selected: Array of selected tag IDs
//   tagAdded: callback when a tag is selected in the dropdown
//   tagRemoved: callback when a tag is removed via the delete x
//   isExclusion: true when this is a filter dropdown for exclusions
//   groupedOptions: true if +options+ is an array of OPTGROUPs
//                   The options top level is ['group label', options_array], where options_array
//                   is defined as above.
export class FilterSelector extends React.Component {
  static propTypes = {
    params: PropTypes.string,
    options: PropTypes.array,
    labels: PropTypes.object,
    selected: PropTypes.array,
    tagAdded: PropTypes.func,
    tagRemoved: PropTypes.func,
    isExclusion: PropTypes.bool,
    groupedOptions: PropTypes.bool,
    blankLabel: PropTypes.string,
    className: PropTypes.string
  };

  static defaultProps = {
    blankLabel: "",
    isExclusion: false,
    groupedOptions: false,
    className: 'filter-selector'
  };

  constructor(...args) {
    super(...args);
    this.removeTag = this.removeTag.bind(this);
    this.addTag = this.addTag.bind(this);
  }

  removeTag(id, event) {
    if (typeof this.props.tagRemoved === 'function') {
      this.props.tagRemoved(id, this.props.isExclusion);
    }
    return event.preventDefault();
  }

  addTag(event) {
    const id = this.refs.selectedTag.value;
    if (typeof this.props.tagAdded === 'function') {
      this.props.tagAdded(id, this.props.isExclusion);
    }
    return event.stopPropagation();
  }

  render() {
    let options; let selected_items;
    let option;
    if (this.props.selected != null) {
      selected_items = (() => {
        const result = [];
        for (const id of Array.from(this.props.selected)) {
          const name = this.props.labels[id];
          result.push(<SelectedFilterTag key={id} onRemove={this.removeTag.bind(this, id)} name={name}>{name}</SelectedFilterTag>);
        }
        return result;
      })();
    }

    if (this.props.groupedOptions) {
      options = (() => {
        const result1 = [];
        for (var group of Array.from(this.props.options)) {
          const group_options = ((() => {
            const result2 = [];
            for (option of Array.from(group[1])) {                     result2.push(<option key={option[1]} value={option[1]}>{option[0]}</option>);
            }
            return result2;
          })());
          result1.push(<optgroup label={group[0]} key={group[0]}>
            {group_options}
          </optgroup>);
        }
        return result1;
      })();
    } else {
      options = ((() => {
        const result3 = [];
        for (option of Array.from(this.props.options)) {                 result3.push(<option key={option[1]} value={option[1]}>{option[0]}</option>);
        }
        return result3;
      })());
    }

    return <div className={this.props.className}>
      <select value=""
              onChange={this.addTag}
              ref="selectedTag"
              className={this.props.inputClassName}
              id={this.props.id}>
        <option key="0" value="">{this.props.blankLabel}</option>
        {options}
      </select>

      <div className="picked_item_list">
        {selected_items}
      </div>
    </div>;
  }
}